import { Skeleton } from '@ths/ui';

export function TripSummarySkeleton() {
  return (
    <div role="status" aria-label="Loading trip details" className="space-y-5">
      <span className="sr-only">Loading trip details</span>
      <Skeleton className="aspect-[16/8] w-full" />
      <div className="space-y-2 border-b border-separator pb-5">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-full" />
      </div>
      {[4, 3, 5].map((rows, section) => (
        <div key={section} className="space-y-3">
          <Skeleton className="h-5 w-1/3" />
          {Array.from({ length: rows }, (_, row) => (
            <div key={row} className="flex justify-between gap-4">
              <Skeleton className="h-4 w-1/2" />
              <Skeleton className="h-4 w-1/4" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
